<template>
  <modal ref="modal" contentClasses="px-5 py-4" :hidesOnClickOut="false">
    <template v-slot:header>
      <p class="font-weight-semibold text-center">Rifiuta cliente</p>
    </template>

    <template v-slot>
      <content-loading
        :active.sync="rejectPlaceRequest.loading"
        :is-full-page="false"
        v-if="rejectPlaceRequest"
      />

      <display-errors :tag="requestTag"></display-errors>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Motivo del rifiuto</label>
            <textarea
              class="form-control grey"
              type="email"
              v-model="rejectionReason"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="row w-100">
        <div class="col-6 pl-0">
          <button
            type="button"
            class="btn btn-outline-primary w-100"
            @click.prevent="onCancel"
          >
            Annulla
          </button>
        </div>
        <div class="col-6 pr-0">
          <button
            type="submit"
            class="btn btn-primary w-100"
            @click.prevent="rejectPlace"
            :disabled="!valid || rejectPlaceRequest.loading"
          >
            Rifiuta cliente
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script lang="ts">
import { Component, Vue, Prop, Mixins } from "vue-property-decorator";
import PlacesMixin from "mixins/http/PlacesMixin";
import { RegisterHttp } from "utils/Decorators";
import { RequestData } from "store/types";
import Modal from "components/Modal.vue";
import Loader from "vue-spinner/src/PulseLoader.vue";
import { showToast } from "utils/Toast";

@Component({ components: { Modal, Loader } })
export default class RejectPlace extends Mixins(PlacesMixin) {
  static readonly rejectPlaceTag = "reject_place";
  private rejectionReason?: string = null;

  @Prop()
  placeId: string | number;

  @RegisterHttp(RejectPlace.rejectPlaceTag) rejectPlaceRequest: RequestData;

  get valid() {
    return this.rejectionReason;
  }

  get requestTag() {
    return RejectPlace.rejectPlaceTag;
  }

  show() {
    const modal = this.$refs.modal as any;
    modal.show();
  }

  hide() {
    this.reset;
    const modal = this.$refs.modal as any;
    modal.hide();
  }

  reset() {
    this.rejectionReason = null;
  }

  rejectPlace() {
    const data = {
      id: this.placeId,
      rejectionReason: this.rejectionReason,
    };

    this.reject(data, RejectPlace.rejectPlaceTag).then((resp) => {
      this.onSaved();
      showToast("Contatto rifiutato con successo!");
    });
  }

  onSaved() {
    this.hide();
    this.$emit("rejected");
  }

  onCancel() {
    this.hide();
    this.$emit("canceled");
  }
}
</script>

<style scoped>
textarea {
  height: 200px;
}
</style>
